let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5VCId")).then(() => parcelRequire('1BVGI'));